import { Routes as ListRoutes, Route, Navigate } from "react-router-dom";
import Login from "./Login";
import SignUp from "./SignUp";
import { useContext, useEffect, useState } from "react";
import { AppContext } from "../context/AppContext";
import Header from "./Header";
import Footer from "./Footer";
import Dashboard from "./Dashboard";
import Settings from "./Settings";
import { checkLogin } from "../services/authServices";
import AdminLogin from "./AdminLogin";
import { checkAdminLogin } from "../services/adminServices";
import { AdminDashboard } from "./AdminDashboard";
import { AdminCompanies } from "./AdminCompanies";
import { AdminSettings } from "./AdminSettings";
import { AdminCompanyDetails } from "./AdminCompanyDetails";
import CompanyKeys from "./CompanyKeys";
import AdminKeyRequest from "./AdminKeyRequest";
import Advertisment from "./Advertisment";
import { VersionManager } from "./VersionManager";

function Routes() {
  const { setLogin, login } = useContext(AppContext);
  const [isLoading, setIsLoading] = useState(true);
  const [domainType, setDomainType] = useState("other"); // "admin", "customer", or "other"

  const checkLoginData = async (token) => {
    try {
      let result = await checkLogin(token);
      setLogin({
        ...login,
        isLogin: true,
        token,
        user: result.user,
        userRole: 0,
      });
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false);
  };

  const checkAdminLoginData = async (token) => {
    try {
      let result = await checkAdminLogin(token);
      setLogin({
        ...login,
        isLogin: true,
        token,
        user: result.user,
        userRole: 1,
      });
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    // Detect domain
    const hostname = window.location.hostname;
    if (hostname === "master.prabhuchat.com") {
      setDomainType("admin");
    } else if (hostname === "customer.prabhuchat.com") {
      setDomainType("customer");
    } else {
      setDomainType("other");
    }

    const token = localStorage.getItem("token");
    const userRole = localStorage.getItem("userRole");

    if (token && !userRole) {
      checkLoginData(token);
    } else if (token && userRole) {
      checkAdminLoginData(token);
    } else {
      setIsLoading(false);
    }
  }, []);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <div className="row">
        {login.isLogin && <Header />}
        <ListRoutes>
          {login.isLogin ? (
            <>
              {!login.userRole && <Route path="/dashboard" element={<Dashboard />} />}
              {!login.userRole && <Route path="/settings" element={<Settings />} />}
              {!login.userRole && <Route path="/requestedKeys" element={<CompanyKeys />} />}

              {login.userRole && <Route path="/advertisement" element={<Advertisment />} />}
              {login.userRole && <Route path="/versions" element={<VersionManager />} />}
              {login.userRole && <Route path="/keysRequest" element={<AdminKeyRequest />} />}
              {login.userRole && <Route path="/adminDashboard" element={<AdminDashboard />} />}
              {login.userRole && <Route path="/adminSettings" element={<AdminSettings />} />}
              {login.userRole && <Route path="/companies" element={<AdminCompanies />} />}
              {login.userRole && <Route path="/:id/details" element={<AdminCompanyDetails />} />}

              {login.userRole
                ? <Route path="*" element={<Navigate to="/adminDashboard" />} />
                : <Route path="*" element={<Navigate to="/dashboard" />} />}
            </>
          ) : (
            <>
              {domainType === "admin" && (
                <Route path="/" element={<AdminLogin />} />
              )}
              {domainType === "customer" && (
                <Route path="/" element={<Login />} />
              )}
              {domainType === "other" && (
                <>
                  <Route path="/login" element={<Login />} />
                  <Route path="/adminLogin" element={<AdminLogin />} />
                  <Route path="/signup" element={<SignUp />} />
                  <Route path="*" element={<Navigate to="/login" />} />
                </>
              )}
              {/* Redirect / to correct page */}
              {domainType === "admin" && <Route path="*" element={<Navigate to="/" />} />}
              {domainType === "customer" && <Route path="*" element={<Navigate to="/" />} />}
            </>
          )}
        </ListRoutes>
      </div>
      <div className="row">
        {login.isLogin && <Footer />}
      </div>
    </>
  );
}

export default Routes;
